import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const RulerIcon = createIcon({
  displayName: 'RulerIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <line x1="12.62" x2="14.14" y1="14.15" y2="15.67"></line>
        <line x1="15.15" x2="16.67" y1="11.62" y2="13.14"></line>
        <line x1="17.68" x2="19.2" y1="9.08" y2="10.6"></line>
        <line x1="10.08" x2="11.6" y1="16.68" y2="18.2"></line>
        <path d="M14.291 7.915l-5.376 5.376 -1.6027e-08-1.6027e-08c-1.48454-1.48454-1.48454-3.89146 3.20541e-08-5.376 1.48454-1.48454 3.89146-1.48454 5.376 3.20541e-08Z"></path>
        <path d="M6.227 15.979l-.958.958 2.85838e-08-2.88446e-08c-.347628.350799-.347628.916201-5.71677e-08 1.267l2.531 2.534 8.16768e-08 8.0812e-08c.350681.346968.915319.346968 1.266-1.61624e-07l12.672-12.669 -4.70793e-09 4.75831e-09c.346968-.350681.346968-.915319 9.41586e-09-1.266l-2.538-2.534 1.86844e-08 1.85155e-08c-.350799-.347628-.916201-.347628-1.267-3.70309e-08l-.958.958 -7.79916e-09-7.79625e-09c-2.96908-2.96798-7.78202-2.96708-10.75.00200002 -2.96798 2.96908-2.96708 7.78202.00200002 10.75Z"></path>
      </g>
      <rect width="24" height="24" fill="none"></rect>
    </>
  ),
})

const Ruler: FC<IconProps> = (props) => {
  return <CustomIcon as={RulerIcon} {...props} />
}

export default memo(Ruler)
